export const operationGiveThanks = `
# Operation Give Thanks
<div id="video"> https://www.youtube.com/embed/RtVLHCjIMkY </div>

</br>
Operation Give Thanks is a company-and customer-supported program designed to aid active-duty service members, veterans, and their families using various armed forces related charities in Kwik Fill Country.
</br></br>
<a href="https://www.operationgivethanks.com" id="button">Learn More</a>
</br></br>
</br>
</br>
</br>
`